/**
 * Shared layout constants for consistent spacing across navbar, hero, and other sections.
 * 150px horizontal padding at 1440px viewport; 10.417vw = 150/1440 scales proportionally.
 */
export const HORIZONTAL_PADDING = 'clamp(24px, 10.417vw, 150px)';
